/**
 * Mobile menu functionality for header-2
 * Handles burger menu toggle and submenu expansion
 */

document.addEventListener('DOMContentLoaded', function() {
  const burger = document.querySelector('.header .burger');
  const mobileMenu = document.querySelector('.header__nav-mobile');
  
  if (!burger || !mobileMenu) return;
  
  // Find SHOP menu item (second li in mobile menu)
  const shopMenuItem = mobileMenu.querySelector('ul > .header__nav-item:nth-child(2)');
  const shopLink = shopMenuItem?.querySelector('.header__nav-link');
  const shopDropdown = shopMenuItem?.querySelector('.dropdown-menu');
  const shopArrow = shopLink?.querySelector('img');

  // Find Science menu item (third li in mobile menu)
  const scienceMenuItem = mobileMenu.querySelector('ul > .header__nav-item:nth-child(3)');
  const scienceLink = scienceMenuItem?.querySelector('.header__nav-link');
  const scienceDropdown = scienceMenuItem?.querySelector('.dropdown-menu');
  const scienceArrow = scienceLink?.querySelector('img');

  // Toggle mobile menu
  burger.addEventListener('click', function(e) {
    e.stopPropagation();
    const isOpen = mobileMenu.classList.contains('is-open');
    
    if (isOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  // Toggle shop submenu
  if (shopLink && shopDropdown) {
    shopLink.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isSubmenuOpen = shopDropdown.classList.contains('is-open');
      
      if (isSubmenuOpen) {
        closeSubmenu(shopDropdown, shopArrow);
      } else {
        openSubmenu(shopDropdown, shopArrow);
      }
    });
  }

  // Toggle science submenu
  if (scienceMenuItem && scienceLink && scienceDropdown) {
    scienceMenuItem.addEventListener('click', function(e) {
      const target = e.target;
      if (!(target instanceof Element)) return;

      // If clicked exactly on the link (the <a> but not the arrow)
      // Note: clicking the text node inside <a> will bubble up and e.target will be the element containing it.
      if (target === scienceLink) {
        return; // Allow navigation
      }

      // If clicked inside the dropdown itself, don't toggle
      if (target.closest('.dropdown-menu')) {
        return;
      }

      // For everything else (Arrow, LI padding, etc.), toggle the dropdown
      e.preventDefault();
      e.stopPropagation();
      
      const isSubmenuOpen = scienceDropdown.classList.contains('is-open');
      
      if (isSubmenuOpen) {
        closeSubmenu(scienceDropdown, scienceArrow);
      } else {
        // Optional: close shop submenu if it's open
        if (shopDropdown && shopDropdown.classList.contains('is-open')) {
          closeSubmenu(shopDropdown, shopArrow);
        }
        openSubmenu(scienceDropdown, scienceArrow);
      }
    });
  }

  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    if (mobileMenu.classList.contains('is-open')) {
      if (!mobileMenu.contains(e.target) && !burger.contains(e.target)) {
        closeMobileMenu();
      }
    }
  });

  // Close menu on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  function openMobileMenu() {
    mobileMenu.classList.add('is-open');
    burger.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove('is-open');
    burger.classList.remove('is-active');
    document.body.style.overflow = '';
    
    // Close submenu if open
    if (shopDropdown && shopDropdown.classList.contains('is-open')) {
      closeSubmenu(shopDropdown, shopArrow);
    }
  }

  function openSubmenu(dropdown, arrow) {
    dropdown.classList.add('is-open');
    if (arrow) {
      arrow.style.transform = 'rotate(90deg)';
      arrow.style.transition = 'transform 0.3s ease-in-out';
    }
  }

  function closeSubmenu(dropdown, arrow) {
    dropdown.classList.remove('is-open');
    if (arrow) {
      arrow.style.transform = 'rotate(0deg)';
      arrow.style.transition = 'transform 0.3s ease-in-out';
    }
  }
});

